var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"not-found"},[_c('header',[_c('h1',[_vm._v("Nothing here :(")])])])}]

export { render, staticRenderFns }